module.exports = __webpack_public_path__ + "img/wuxinxi.74615479.svg";